import React, { useCallback, useState, useMemo } from 'react';
import { withTranslation } from 'react-i18next';

import FieldDefault from 'components/field-default';

const ResourceItem = ({ id, icon, title, meta, selected, color, itemComponent, onClick }) => {
    const handleClick = useCallback(() => {
        onClick(id);
    }, [id, onClick]);

    return (
        <div className={'item' + (selected ? ' selected' : '')} key={id}>
            <div className="item-inner" style={!selected ? { color } : undefined} onClick={handleClick}>
                {
                    icon ? (
                        <div className="item-head">
                            { icon }
                        </div>
                    ) : null
                }
                {
                    itemComponent ? React.cloneElement(itemComponent, { id, title, meta, selected }) : (
                        <div className="item-body">
                            <h5>{title}</h5>

                            {
                                meta ? <h6>{ meta }</h6> : null
                            }
                        </div>
                    )
                }

                <div className="item-marker">
                    <i className="ion ion-checkmark" />
                </div>
            </div>
        </div>
    );
};

const ResourceSelector = ({ items = [], withSearch, searchPlaceholder, emptyText, resourceCreateText, selected, loading, itemComponent, t, onSelect, onResourceCreate }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const filteredItems = useMemo(() => {
        if (searchTerm) {
            return items.filter(({ searchTitle, title, meta }) => ((searchTitle || title || '') + (typeof meta === 'string' ? meta : '')).toLowerCase().indexOf(searchTerm.toLowerCase()) > -1)
        }

        return items;
    }, [searchTerm, items]);

    return (
        <div className="resource-selector">
            {
                items.length && withSearch ? (
                    <FieldDefault
                        small={true}
                        placeholder={searchPlaceholder ?? (t('Search') + '…')}
                        value={searchTerm}
                        autoFocus={true}
                        onChange={setSearchTerm}
                    />
                ) : null
            }

            {
                loading ? (
                    <p className="no-resources">{ t('Loading results') }</p>
                ) : (
                    <>
                        <div className="resource-selector-body nice-scroll">
                            {
                                filteredItems.length ? filteredItems.map(item => (
                                    <ResourceItem
                                        key={item.id}
                                        id={item.id}
                                        icon={item.icon}
                                        title={item.title}
                                        meta={item.meta}
                                        color={item.color}
                                        selected={Array.isArray(selected) ? selected.includes(item.id) : selected === item.id}
                                        itemComponent={itemComponent}
                                        onClick={onSelect}
                                    />
                                )) : items.length ? (
                                    <p className="no-resources">{ t('No results matching the filter') }</p>
                                ) : (
                                    <div className="no-resources">
                                        <p>
                                            { emptyText ?? t('No Results') }
                                        </p>
                                     </div>
                                )
                            }
                        </div>

                        {
                            onResourceCreate ? (
                                <div className="resource-selector-foot">
                                    <button className="btn btn-link btn-colored" onClick={onResourceCreate}>{ resourceCreateText || t('Create') }</button>
                                </div>
                            ) : null
                        }
                    </>
                )
            }
        </div>
    );
};

export default withTranslation('common')(ResourceSelector);
